import { HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { AuthStore } from "../+state/auth";
import { inject } from "@angular/core";

export const httpHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  let newReq = req;
  if (authStore.token() && !exemptUrls(newReq)) {
    newReq = newReq.clone({
      headers: newReq.headers.append("Authorization", `Bearer ${authStore.token()!}`),
    });
  }
  return next(newReq);
};

const exemptUrls = (req: HttpRequest<unknown>) => {
  return req.url.includes("oauth") || req.url.includes("config.json");
};
